export default class config {
    static get baseUrl() {
        return "";
    }


    // урл папки бэкенда на сайте клиники (слеш обязателен)
    static get dataUrl() {
        return "https://medangel.angelsit.ru/backend/integra-nvrsk.ru/medangel-backend/"
        // return "http://localhost:8100/"
    }

    // урл политики конфеденциальности на сайте клиники
    static get privateUrl() {
        return "https://integra-nvrsk.ru/dokumenty-license"
    }


    static get partnerId() {
        return window.nebolitpro._partnerId;
    }

    /* For appointment widget only. */
    static get clinicId() {
        return 5;
    }

    static get scheduleLength() {
        return 7;
    }

    static get yandexMetrikaConfig() {
        return {
            id: 0,
        };
    }
}


/** WEBPACK FOOTER **
 ** ./src/config.js
 **/